
import Axios from 'axios'
import * as Sentry from '@sentry/browser'
import config from '../config'
import { debug } from '../utilities/logger'

if (config['vendors-activated']) {
  Sentry.init({
    environment: config.environment,
    dsn: 'https://5c6621c7fab0455794d61ec8882cebe2@sentry.io/1841330'
  })

  Axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    Sentry.addBreadcrumb({
      category: 'url',
      level: 'info',
      message: error.config.url
    })
      // Things will be redacted by Sentry (like personal informations) so don't worry
    Sentry.addBreadcrumb({
      category: 'data',
      level: 'info',
      message: JSON.stringify(error.config.data)
    })
    Sentry.addBreadcrumb({
      category: 'response',
      level: 'info',
      message: error.response.data ? JSON.stringify(error.response.data) : error.request.responseText
    })
    Sentry.captureException(error)
    return Promise.reject(error)
  })
} else {
  debug(`[vendors][Sentry] Deactivated cause not in production`)
}



// WEBPACK FOOTER //
// ./src/vendors/Sentry.js